<template>
  <div>
    <pxkeji-rightHeader />

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn name="ceshi" type="primary" size="large" roles="设备新增,设备编辑"  icon="search"  />  -->

      <a-form class="ant-advanced-search-form">

        <a-row :gutter="24">
          <a-col :span="6">
            <a-form-item label="子站集合">
              <a-select show-search :filter-option="filterOption" mode="multiple" v-model="where.keyword.data_zone"
                        allowClear @change="changeDataZone">
                <a-select-option :value="subinfo.id" v-for="(subinfo, index) in where.subsites"
                                 :key="index + '--' + subinfo.name">{{ subinfo.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="素材名称">
              <a-input placeholder="请输入素材名称" v-model="where.keyword.material_name" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="课程名称">
              <a-input placeholder="请输入课程名称" v-model="where.keyword.course_name" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="学员信息">
              <a-input placeholder="姓名/手机号/身份证" v-model="where.keyword.name" allow-clear/>
            </a-form-item>
          </a-col>
          <!--          <a-col :span="6">
                      <a-form-item label="课程分类">
                        <a-cascader
                            allowClear
                            changeOnSelect
                            :fieldNames="{
                            label: 'name',
                            value: 'id',
                            children: 'children',
                          }"
                            :options="where.keyword.type"
                            @change="treeChange"
                            placeholder="请选择分类"
                        />
                      </a-form-item>
                    </a-col>-->
          <a-col :span="6">
            <a-form-item label="操作时间">
              <a-range-picker format="YYYY-MM-DD" :placeholder="['开始时间', '结束时间']" @change="onTimeChange" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
<!--            <a-button type="primary" @click="searchList" v-btnlimit="'点击记录-搜索'">搜索</a-button>-->
            <a-button type="primary" @click="searchList">搜索</a-button>

          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="pxkeji-right-box">
      <!-- <pxkeji-btn
        name="添加素材"
        class="pxkeji_basic_btn"
        :roles="['暂停广告-添加']"
        v-btnlimit="'暂停广告-添加'"
        @click="showInfo({'id':0})"
        type="primary"
      /> -->
      <pxkeji-btn name="导出Excel" :roles="[]" class="pxkeji_basic_btn" @click="exportData()" v-btnlimit="'子站广告统计-导出Excel'"/>
      <!-- <a-button type="primary" @click="exportData" >导出</a-button> -->
      <div class="totalbox" style="margin-bottom:10px;margin-top:10px;">
        <div>
          <span>共有：{{list.pagination.total}}条数据</span>
        </div>
      </div>
      <a-table
          :columns="list.columns"
          :pagination="list.pagination"
          @change="onChange"
          :dataSource="list.datas"
          :loading="isloading"
          :locale="{emptyText:'暂无数据'}"
          :rowKey="(record, index) => record.index"
      >

      <span slot="material_image_url" slot-scope="material_image_url">
         <image-preview
             max-scale="3"
             min-scale="0.6"
             scale-step="0.2">
           <img   :src="material_image_url" style="width:60px;height:50px;margin: 0 3px;"/>
        </image-preview>
      </span>
        <span slot="telephone" slot-scope="text, record">
         <span @click="showDetails_telephone(record.id)">{{record.telephone}}</span>
      </span>
        <span slot="id_card" slot-scope="text, record">
         <span @click="showDetails_idCard(record.id)">{{record.id_card}}</span>
      </span>

        <span slot="link_url" slot-scope="link_url">
         <a :href="link_url"  target="_blank" v-if="link_url">{{link_url}}</a>
         <span v-else>暂无</span>
      </span>


      </a-table>

    </div>


  </div>
</template>
<script>
var that;
// import Info from "./advertPauseInfo.vue"; //新增编辑
// import CourseTypes from "./advertCourseType.vue" // 投放分类

const columns = [
  {
    dataIndex: "data_zone_name",
    key: "data_zone_name",
    align: "center",
    title: "站点",
    scopedSlots: { customRender: "data_zone_name" }
  },

  {
    dataIndex: "add_time",
    key: "add_time",
    align: "center",
    title: "操作时间"
  },
  {
    dataIndex: "course_type_name",
    key: "course_type_name",
    align: "center",
    title: "课程分类"
  },
  {
    dataIndex: "material_name",
    key: "material_name",
    align: "center",
    title: "素材名称"
  },
  {
    dataIndex: "course_name",
    key: "course_name",
    align: "center",
    title: "课程名称"
  },
  {
    dataIndex: "material_image_url",
    key: "material_image_url",
    align: "center",
    title: "素材",
    scopedSlots: { customRender: "material_image_url" }
  },
  {
    dataIndex: "link_url",
    key: "link_url",
    align: "center",
    title: "素材链接",
    width: 250,
    scopedSlots: { customRender: "link_url" }
  },
  {
    dataIndex: "full_name",
    key: "full_name",
    align: "center",
    title: "学员"
  },
  {
    dataIndex: "telephone",
    key: "telephone",
    align: "center",
    title: "手机号",
    scopedSlots: { customRender: "telephone" }
  },
  {
    dataIndex: "id_card",
    key: "id_card",
    align: "center",
    title: "身份证号",
    scopedSlots: { customRender: "id_card" }
  },
  {
    dataIndex: "province",
    key: "province",
    align: "center",
    title: "地区",
  },
  {
    dataIndex: "company",
    key: "company",
    align: "center",
    title: "单位名称"
  },
  {
    dataIndex: "job_set",
    key: "job_set",
    align: "center",
    title: "职称系列"
  },
  {
    dataIndex: "job_title",
    key: "job_title",
    align: "center",
    title: "职称"
  },

];

export default {
  name: "advertRecord",
  data() {
    return {
      expand: false, //高级搜索
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      //   addedit: {
      //     title: "",
      //     info: {},
      //     id: 0,
      //     visible: false
      //   },
      //adv_course_type:"投放分类",
      //adv_course_type_visible:false, // 投放分类弹窗显示与关闭
      where: {
        //查询条件
        keyword: {
          //搜索条件
          name:"", // 姓名/手机号/身份证查询条件
          startTime:"", // 开始时间
          endTime:"", // 结束时间
          type: [],
          data_zone:[],
          material_name: "",  // 素材名称
          course_name:"" , // 课程名称
          course_type_name: "", // 课程分类
          course_type_id:""
        },
      },
      //selectRows: [], //选中项编号
      isloading: false,

    };
  },
//   components: {
//     Info: Info,
//     CourseTypes:CourseTypes
//   },
  mounted: function() {
    this.$nextTick(function() {
      that = this;
      this.GetList();
      this.GetCateList(); //获取课程分类
      this.getSubsites();

    });
  },

//   watch: {
//     selectRows: function() {
//       //console.log("watch", val);
//     }
//   },
  methods: {
    getSubsites() {
      this.$api.area.getAllSubsitesList().then((res) => {
        if (res.errorCode == this.$msg.responseCode.success) {
          this.where.subsites = res.data
        } else {
          this.error(res.errorMsg);
        }
      })
          .catch(() => {
            this.error();
          });
    },
    //手机号脱敏
    showDetails_telephone(id) {
      var that = this;
      this.$api.advertistop
          .getByTelephone({
            id: id
          })
          .then(res => {
            if (res.errorCode === "0000") {
              this.list.datas = this.list.datas.map(item => {
                if (item.id == id) {
                  item.telephone = res.data.telephone
                }
                return item
              })

            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
    },
    //身份证号脱敏
    showDetails_idCard(id) {
      var that = this;
      this.$api.advertistop
          .getByIdcard({
            id: id
          })
          .then(res => {
            if (res.errorCode === "0000") {
              this.list.datas = this.list.datas.map(item => {
                if (item.id == id) {
                  item.id_card = res.data.id_card

                }
                return item
              })

            } else {
              this.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
    },
    filterOption(input, option) {
      return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    exportData() {
      var param = {
        name: this.where.keyword.name,
        material_name: this.where.keyword.material_name,
        course_name: this.where.keyword.course_name,
        course_type_id: this.where.keyword.course_type_id,
        data_zone: this.where.keyword.data_zone,
        startTime: this.where.keyword.startTime,
        endTime: this.where.keyword.endTime,

      }
      window.location.href = this.$api.excel.exportAdvertRecordData(param);

      //  window.location.href = this.$api.lives.exportAdvertRecordData(param);
    },
    onTimeChange(date, dateString) {
      // 时间选择器
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },

    GetCateList() {
      //获取列表
      this.isloading = true;
      this.$api.courseType
          .getTreeByColumnId("", "")
          .then((res) => {
            this.isloading = false;
            if (res.errorCode == this.$msg.responseCode.success) {
              this.where.keyword.type = res.data;
              //console.log('asd',this.where.keyword.type)
            } else {
              that.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
    },
    treeChange(val) {
      //console.log('tree',val)
      this.where.keyword.course_type_id = val[val.length - 1];
    },
    // toggle() {
    //   this.expand = !this.expand;
    // },
    // filterOption(input, option) {
    //   return (
    //       option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    //   );
    // },
    GetList() {
      //获取列表
      this.isloading = true;
      //this.clearRows();
      //素材列表
      this.$api.advertistop
          .getMaterialRecordListByDateZone({
            pageNow: this.list.pagination.current,  // 当前页数
            pageSize: this.list.pagination.defaultPageSize, // 每页条数
            material_name: this.where.keyword.material_name, // 素材名称
            course_type_id: this.where.keyword.course_type_id, // 课程分类
            data_zone: this.where.keyword.data_zone, // 子站id
            name: this.where.keyword.name, // 姓名/手机号/身份证查询条件
            course_name: this.where.keyword.course_name, // 课程名称
            startTime: this.where.keyword.startTime, // 开始时间
            endTime: this.where.keyword.endTime, // 结束时间
          })
          .then(res => {
            this.isloading = false;
            //console.log("数据列表",res)
            if (res.errorCode == this.$msg.responseCode.success) {
              var item = res.data.records;
              for (let i = 0; i < item.length; i++) {
                if (item[i].city) {
                  item[i].province = item[i].province + "/" + item[i].city
                }
                if (item[i].area) {
                  item[i].province = item[i].province + "/" + item[i].area // 2021 09 11
                }
              }
              this.list.datas = res.data.records;
              this.list.pagination.total = Number(res.data.total);
            } else {
              that.$message.error(res.errorMsg);
            }
          })
          .catch(() => {
            this.isloading = false;
          });
    },
    onTimeChange(date, dateString) {
      this.where.keyword.startTime = dateString[0];
      this.where.keyword.endTime = dateString[1];
    },
    onChange(page) {
      //页面切换回调
      this.list.pagination.current = page.current;
      this.GetList();
    },

    // clearRows() {
    //   //清空选中项
    //   this.selectRows = [];
    // },
    searchList() {
      this.list.pagination.current = 1;
      this.GetList();
    },
    //  changeDataZone(v, i) {
    //    this.list.datas = [];
    //    this.list.pagination.total = 0;
    //   // this.where.grouplist = [];
    // //   this.where.keyword.groupId = "";
    //
    //    if (v && v.length == 1) {
    //      //this.getgrouplist();
    //      //this.statusList.groupDisableStatus = false;
    //      //this.statusList.adminStatus = false;
    //      //this.statusList.exportButStatus = false;
    //    } else {
    //    //  this.statusList.groupDisableStatus = true;
    //    //  this.statusList.adminStatus = true;
    //    //  this.statusList.exportButStatus = true;
    //    }
    //  },
    // clear() {
    //   //清空搜索条件
    //   for (var info in this.where.keyword) {
    //     this.where.keyword[info] = "";
    //   }
    // },
    // showInfo(info) {
    //   //打开弹出框
    //     //console.log("info",info)
    //    this.addedit.visible = true;
    //    this.addedit.title = info.id ? "编辑" : "新增";
    //    this.addedit.info = info;
    // },
    // showCourseTypes(info){
    //     //打开投放分类弹窗
    //     this.adv_course_type_visible = true;
    //     this.addedit.info = info;
    // },
    // /*批量启用 */
    // batchEnable() {
    //   this.handleProhibit(this.selectRows.join(","), 1);
    // },
    /*批量禁用 */
    // batchDisEnable() {
    //   this.$confirm({
    //     title: "您确定要执行批量禁用的操作吗?",
    //     okText: "确定",
    //     okType: "danger",
    //     cancelText: "我再想想",
    //     onOk() {
    //       that.handleProhibit(that.selectRows.join(","), 0);
    //     },
    //     onCancel() {}
    //   });
    // },
    /**单个启用禁用 */
    // handleStatus(ids, status) {
    //   if (status == 0) {
    //     this.$confirm({
    //       title: "您确定要执行禁用的操作吗?",
    //       okText: "确定",
    //       okType: "danger",
    //       cancelText: "我再想想",
    //       onOk() {
    //         that.handleProhibit(ids, 0);
    //       },
    //       onCancel() {}
    //     });
    //   } else {
    //     that.handleProhibit(ids, 1);
    //   }
    // },
    /*禁用启用 */
    // handleProhibit(ids, status) {
    //   that.isloading = true;
    //   that.$api.advertistop
    //     .setMaterialStatus({id:ids,status:status})
    //     .then(res => {
    //       that.isloading = false;
    //       if (res.errorCode == that.$msg.responseCode.success) {
    //         that.$message.success(res.errorMsg);
    //         that.GetList();
    //       } else {
    //         that.$message.error(res.errorMsg);
    //       }
    //     })
    //     .catch(() => {
    //       that.isloading = false;
    //     });
    // },
    /**删除 */
    // delInfo(id) {
    //   this.$confirm({
    //     title: "您确定要删除此项吗?",
    //     okText: "确定",
    //     okType: "danger",
    //     cancelText: "我再想想",
    //     onOk() {
    //       that.isloading = true;
    //       that.$api.advertistop
    //         .deleteMaterial({id:id})
    //         .then(res => {
    //           that.isloading = false;
    //           if (res.errorCode == that.$msg.responseCode.success) {
    //             that.$message.success(res.errorMsg);
    //             that.GetList();
    //           } else {
    //             that.$message.error(res.errorMsg);
    //           }
    //         })
    //         .catch(() => {
    //           that.isloading = false;
    //         });
    //     },
    //     onCancel() {}
    //   });
    // },

    // save() {
    //   this.addedit.visible = false;
    //   this.adv_course_type_visible = false;
    //   this.GetList();
    // }
  }
};
</script>

<style>
.ant-advanced-search-form .ant-form-item {
  display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  flex: 1;
}

#components-form-demo-advanced-search .ant-form {
  max-width: none;
}

.ant-table-tbody > tr > td {
  padding: 16px 5px;
  overflow-wrap: break-word;
}

#components-form-demo-advanced-search .search-result-list {
  margin-top: 16px;
  border: 1px dashed #e9e9e9;
  border-radius: 6px;
  background-color: #fafafa;
  min-height: 200px;
  text-align: center;
  padding-top: 80px;
}
</style>

